module.exports = "/images/trec-preview-3.jpg?4628b20f31a6603332e1850b6d5cea4d";